import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, X } from 'lucide-react';
export function TargetAudience() {
  const forYou = ['Madres en USA que quieren ingresos extras sin descuidar a su familia.', 'Personas con cero experiencia en diseño gráfico pero con muchas ganas de aprender.', "Emprendedoras que buscan un negocio de 'activos digitales' (crear una vez, vender mil veces).", 'Quienes tienen poco tiempo (menos de 1 hora al día) para dedicarle a un negocio.'];
  const notForYou = ["Personas buscando 'dinero mágico' sin hacer absolutamente nada de trabajo.", 'Quienes no estén dispuestos a seguir un manual paso a paso.', 'Artistas profesionales que prefieren métodos manuales tradicionales.'];
  return <section className="py-16 md:py-24 bg-cream px-4 sm:px-6 lg:px-8" data-id="element-212">
      <div className="max-w-6xl mx-auto" data-id="element-213">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-214">
          <FadeIn direction="right" data-id="element-215">
            <div className="bg-white p-8 md:p-10 rounded-3xl shadow-card border-t-4 border-green-400 h-full" data-id="element-216">
              <h3 className="text-2xl font-heading font-bold text-darkText mb-8 flex items-center gap-3" data-id="element-217">
                <div className="bg-green-100 p-2 rounded-full" data-id="element-218">
                  <Check className="w-6 h-6 text-green-600" data-id="element-219" />
                </div>
                Esto es para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-220">
                {forYou.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-221">
                    <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-1" data-id="element-222" />
                    <span className="text-lightText" data-id="element-223">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn direction="left" delay={0.2} data-id="element-224">
            <div className="bg-white p-8 md:p-10 rounded-3xl shadow-card border-t-4 border-red-400 h-full" data-id="element-225">
              <h3 className="text-2xl font-heading font-bold text-darkText mb-8 flex items-center gap-3" data-id="element-226">
                <div className="bg-red-100 p-2 rounded-full" data-id="element-227">
                  <X className="w-6 h-6 text-red-600" data-id="element-228" />
                </div>
                NO es para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-229">
                {notForYou.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-230">
                    <X className="w-5 h-5 text-red-400 flex-shrink-0 mt-1" data-id="element-231" />
                    <span className="text-lightText" data-id="element-232">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}